"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CivicEngage6Logo = _interopRequireDefault(require("./CivicEngage6Logo"));

var _CivicEngageLogo = _interopRequireDefault(require("./CivicEngageLogo"));

var _CivicHrLogo = _interopRequireDefault(require("./CivicHrLogo"));

var _CivicReadyLogo = _interopRequireDefault(require("./CivicReadyLogo"));

var _CivicRecLogo = _interopRequireDefault(require("./CivicRecLogo"));

var _PlatformLogo = _interopRequireDefault(require("./PlatformLogo"));

var ProductLogos = {
  civicplusplatform: _PlatformLogo.default,
  civicrec: _CivicRecLogo.default,
  civicready: _CivicReadyLogo.default,
  civichr: _CivicHrLogo.default,
  civicengage: _CivicEngageLogo.default,
  civicengage6: _CivicEngage6Logo.default
};
var _default = ProductLogos;
exports.default = _default;